import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component, Input } from '@angular/core';
import { NoFlyTime } from '../../../models';
import { PassesAnimations } from '../../passes.animations';

@Component({
	selector: 'sp-no-fly-time',
	templateUrl: './no-fly-time.component.html',
	styleUrls: ['./no-fly-time.component.scss'],
	animations: [PassesAnimations.TooltipFadeInOut],
})
export class NoFlyTimeComponent {
	@Input() isActive = false;
	@Input() until = '';
	@Input() noFlyTimeTooltipHeight = 0;
	@Input() noFlyTimeTooltipPosition: ConnectedPosition[];
	@Input() hasActivePassRequest = false;
	@Input() noFlyTimes: NoFlyTime[] = [];
	@Input() currentNoFlyTimeIndex = 0;

	isOpenNoFlyTimeTooltip = false;

	showNoFlyTimeTooltip(): void {
		this.isOpenNoFlyTimeTooltip = true;
	}

	closeNoFlyTimeTooltip(): void {
		this.isOpenNoFlyTimeTooltip = false;
	}
}
